export default {
  close: 'Fechar'
}
